import { cn } from '@invent/wl-ui-kit-next';

import { HelpPopover } from '@/design';
import type { IExcludedCount } from '../../api/mail-campaign-contracts';

/**
 * The participants a bulk mail leaves out on purpose — "Excluded 3: Deceased 1 · Retired 2" — with
 * a "?" saying who they are. Only the reasons that count anyone; nothing when nobody is excluded.
 */
export function ExcludedLine({ excluded, className }: { excluded: readonly IExcludedCount[]; className?: string }) {
  const counted = excluded.filter((reason) => reason.count > 0);
  if (counted.length === 0) return null;
  const total = counted.reduce((sum, reason) => sum + reason.count, 0);
  return (
    <span className={cn('flex items-center gap-x-1', className)} data-excluded="">
      <span className="min-w-0">
        Excluded {total.toLocaleString('en-US')}:{' '}
        {counted.map((reason) => `${reason.reason} ${reason.count.toLocaleString('en-US')}`).join(' · ')}
      </span>
      <HelpPopover label="About excluded participants">
        <p>
          Participants whose record says they must not be written to about this survey — deceased, retired, or marked Do
          Not Contact — are left out of every bulk email and reminder. They are not counted among the recipients.
        </p>
        <p className="text-muted-foreground">
          The reason comes from the participant&apos;s record. Unsubscribed addresses are counted apart: those people asked
          to stop receiving survey emails.
        </p>
      </HelpPopover>
    </span>
  );
}
